import axios from "axios";

const baseUrl = "https://recipe-vti-production.up.railway.app:443/api/v1/notifications";

export const createNotificationApi = async (data) => {
    return await axios.post(baseUrl, data);
}

export const getListNotifiesApi = async (userId) => {
    return await axios.get(baseUrl, {params: {receiverId: userId}});
}